<template>
    <tr
        class="c-o-table__tr c-o-table__tr--flip-at-small c-o-table--with-actions"
        :class="{ 'c-o-table__tr--highlighted': isNew && highlightNew }"
    >
        <td class="c-o-table__td">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Förfrågan:</span
            >
            <router-link
                :to="{
                    name: 'Förfrågan (Mina sidor)',
                    params: { id: request.Id }
                }"
                >{{ request.Title }}</router-link
            >
        </td>
        <td class="c-o-table__td" nowrap>
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Datum:</span
            >
            {{ request.CreatedDate | formatDateWithoutTime }}
        </td>

        <td class="c-o-table__td u-padding-top-2">
            <span v-if="!isDesktop" class="c-o-table__inline-label">Typ:</span>
            <div class="c-o-table__pills">
                <status-pill v-if="request.SecureJob" :status="'active'"
                    >TryggtJobb</status-pill
                >
                <status-pill v-if="request.IsDirectRequest" :status="'active'"
                    >Direktförfrågan</status-pill
                >
                <status-pill v-if="contract.status" :status="contract.status">{{
                    contract.label
                }}</status-pill>
                <status-pill v-if="request.Channel.Name" :status="'active'">{{
                    request.Channel.Name
                }}</status-pill>
            </div>
        </td>

        <td class="c-o-table__td" nowrap>
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Kommun:</span
            >
            {{ request.Region.Name }}
        </td>
        <td class="c-o-table__td">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Kategori:</span
            >
            <span>{{ request.Category.Name }}</span>
        </td>
        <td class="c-o-table__td">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Status:</span
            >
            <div class="c-o-table__td--status-circle-wrap">
                <status-circle :value="answers"></status-circle>
            </div>
        </td>
        <td class="c-o-table__td">
            <span v-if="!isDesktop" class="c-o-table__inline-label">Dölj:</span>
            <div
                @click="hideOrShow(toggleHiddenValue)"
                class="c-o-table__td--status-circle-wrap"
            >
                <img
                    :src="imgShow"
                    :title="titleShow"
                    :alt="titleShow"
                    style="height:16px;width:16px;cursor: pointer;"
                />
            </div>
        </td>
    </tr>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Filters from "../../../filters/index.js";

import ButtonLink from "../atoms/AtomButtonLink.vue";
import StatusPill from "../atoms/AtomStatus.vue";
import StatusCircle from "../atoms/AtomStatusCircle.vue";

import { GET_CONTRACT_REQUEST_IDS } from "../../../store/store-models/contract-model";

import {
    FETCH_COMPANY_ANSWERED_REQUESTS,
    FETCH_COMPANY_REQUESTS,
    UPDATE_HIDDEN_REQUEST
} from "../../../store/store-models/my-pages-company-model";

export default {
    props: {
        request: Object,
        isMatched: Boolean,
        highlightNew: Boolean
    },
    components: {
        ButtonLink,
        StatusPill,
        StatusCircle
    },
    filters: Filters,
    computed: {
        ...mapGetters({
            contractRequestIds: GET_CONTRACT_REQUEST_IDS
        }),
        answers: function() {
            let answers = this.request.AnswerCount;

            if (answers <= 3) {
                return "green";
            }
            if (answers >= 4 && answers <= 5) {
                return "yellow";
            }
            if (answers >= 6) {
                return "red";
            }
        },
        status: function() {
            if (this.request.IsDirectRequest) {
                return {
                    status: "direct",
                    label: "Direkt"
                };
            } else {
                return {
                    status: "",
                    label: ""
                };
            }
        },
        imgShow: function() {
            let imgPath = "/assets/images/icons/";
            return imgPath + (!this.request.IsHidden ? "hide.png" : "show.png");
        },
        titleShow: function() {
            return this.request.IsHidden
                ? "Klicka för att visa"
                : "Klicka för att dölja";
        },
        toggleHiddenValue: function() {
            return this.request;
        },
        contract: function() {
            let index = this.contractRequestIds
                .map(x => x.requestId)
                .indexOf(this.request.Id);
            if (index > -1) {
                let label = "";
                switch (this.contractRequestIds[index].status) {
                    case 1:
                        label = "Avtal begärt";
                        break;
                    case 2:
                        label = "Avtal finns";
                        break;
                }

                return {
                    status: "contract",
                    label: label
                };
            }
            return {
                status: "",
                label: ""
            };
        },
        isDesktop: function() {
            return this.$mq === "medium" ||
                this.$mq === "large" ||
                this.$mq === "xLarge"
                ? true
                : false;
        },
        isNew: function() {
            const FiveDaysAgo = moment().subtract(5, "days");
            return moment(this.request.CreatedDate).isSameOrAfter(
                FiveDaysAgo,
                "days"
            );
        }
    },
    methods: {
        hideOrShow: async function(req) {
            await this.$store.dispatch(UPDATE_HIDDEN_REQUEST, req);
            if (this.$parent.$parent.activeTab == "answered") {
                this.$store.dispatch(FETCH_COMPANY_ANSWERED_REQUESTS);
            } else {
                this.$store.dispatch(FETCH_COMPANY_REQUESTS);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeRequestsListCompanyTableRow.vue